import { Swiper } from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

const sectionTeamSliders = document.querySelectorAll('section.team-slider');

document.addEventListener('DOMContentLoaded', () => {
	sectionTeamSliders.forEach((section) => {
		if (section.querySelector('.swiper-team-slider')) {
			const sectionId = section.getAttribute('id');
			const swiperId = `#${sectionId} .swiper-team-slider`;
			const swiperElement = document.querySelector(swiperId);
			const amount = parseInt(swiperElement.getAttribute('data-count'), 10);
			const desktopAmount = 5;

			new Swiper(swiperId, {
				watchSlidesProgress: true,
				modules: [Navigation, A11y],
				a11y: true,
				grabCursor: true,
				slidesPerView: 1.2,
				spaceBetween: 32,
				speed: 400,
				keyboard: {
					enabled: true,
				},
				navigation: {
					nextEl: `#${sectionId} .swiper-btn-next`,
					prevEl: `#${sectionId} .swiper-btn-prev`,
				},
				breakpoints: {
					640: {
						slidesPerView: 2,
					},
					1024: {
						slidesPerView: desktopAmount,
					},
				},
			});
		}
	});
});
